import { DEVTOOLS_OPTIONS } from '@/modules/debug/constants/zustand';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface FleetTrackerPlaybackStore {
  startTime: Date | undefined;
  endTime: Date | undefined;
  currentTime: Date | undefined;
  currentSpeed: number;
  playing: boolean;
}

interface FleetTrackerPlaybackAction {
  initializePlayback: (startTime: Date, endTime: Date | undefined) => void;
  updateCurrentTime: (currentTime: Date) => void;
  setPlaying: (playing: boolean) => void;
  setCurrentSpeed: (currentSpeed: number) => void;
  setPlayState: (playing: boolean, currentSpeed: number) => void;
}

const initialState: FleetTrackerPlaybackStore = {
  startTime: undefined,
  endTime: undefined,
  currentTime: undefined,
  currentSpeed: 1,
  playing: false,
};

export const useFleetTrackerPlaybackStore = create<
  FleetTrackerPlaybackStore & FleetTrackerPlaybackAction
>()(
  devtools(
    (set) => ({
      ...initialState,
      initializePlayback: (startTime: Date, endTime: Date | undefined) =>
        set(() => ({ startTime, endTime }), undefined, {
          type: 'initializePlayback',
          ...DEVTOOLS_OPTIONS,
        }),
      updateCurrentTime: (currentTime: Date) =>
        set(() => ({ currentTime }), undefined, {
          type: 'updateCurrentTime',
          ...DEVTOOLS_OPTIONS,
        }),
      setPlaying: (playing: boolean) =>
        set(() => ({ playing }), undefined, {
          type: 'setPlaying',
          ...DEVTOOLS_OPTIONS,
        }),
      setCurrentSpeed: (currentSpeed: number) =>
        set(() => ({ currentSpeed }), undefined, {
          type: 'setCurrentSpeed',
          ...DEVTOOLS_OPTIONS,
        }),
      setPlayState: (playing: boolean, currentSpeed: number) =>
        set(() => ({ playing, currentSpeed }), undefined, {
          type: 'setPlayState',
          ...DEVTOOLS_OPTIONS,
        }),
    }),
    { store: 'fleetTrackerPlaybackStore', ...DEVTOOLS_OPTIONS },
  ),
);
